exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "svg{left:0;position:absolute;top:0}line{stroke-width:2;stroke:red}.datum{left:10px}#sacuvaj{bottom:0;right:0;position:fixed}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/komponente/editor/stil.css
// module id = 28
// module chunks = 0